'use client'

import { useEffect, useState } from 'react'
import {
  HERO_POSTER_SRC,
  HERO_VIDEO_MIN_WIDTH_PX,
  HERO_VIDEO_SRC,
  shouldLoadHeroVideo,
} from '@/lib/hero-video'

const DESKTOP_MQ = `(min-width: ${HERO_VIDEO_MIN_WIDTH_PX}px)`
const REDUCE_MQ = '(prefers-reduced-motion: reduce)'

/**
 * High-priority poster is the LCP paint. The 3.1MB mp4 is injected only after
 * mount on desktop without reduced-motion, so mobile never downloads it.
 */
export function HeroBackground() {
  const [loadVideo, setLoadVideo] = useState(false)

  useEffect(() => {
    const desktop = window.matchMedia(DESKTOP_MQ)
    const reduce = window.matchMedia(REDUCE_MQ)

    const sync = () => {
      setLoadVideo(
        shouldLoadHeroVideo({
          desktop: desktop.matches,
          reducedMotion: reduce.matches,
        }),
      )
    }

    sync()
    desktop.addEventListener('change', sync)
    reduce.addEventListener('change', sync)
    return () => {
      desktop.removeEventListener('change', sync)
      reduce.removeEventListener('change', sync)
    }
  }, [])

  return (
    <div className="absolute inset-0" aria-hidden="true">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={HERO_POSTER_SRC}
        alt=""
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
        style={{ objectPosition: 'center 35%' }}
      />
      {loadVideo ? (
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={HERO_POSTER_SRC}
          className="absolute inset-0 h-full w-full object-cover"
          style={{ objectPosition: 'center 35%' }}
        >
          <source src={HERO_VIDEO_SRC} type="video/mp4" />
        </video>
      ) : null}
    </div>
  )
}
